import { convertParams } from 'src/utils/utils'
import axios from '../axios'
import { EVENTROUTES } from 'src/router/Api'
export const getListEvent = async (params) => {
	return await axios.get(EVENTROUTES.name, {
		params: convertParams(params),
	})
}
export const getListCustomEvent = async (params) => {
	const {
		filter_type,
		title,
		search_type,
		search_value,
		sort,
		country_filter,
		...rest
	} = params

	return await axios.get(EVENTROUTES.customEvents, {
		params: {
			...convertParams(rest),
			filter_type,
			title,
			search_type,
			search_value,
			sort,
			country_filter,
		},
	})
}
export const getCustomEventStatistics = async () => {
	return await axios.get(EVENTROUTES.customEventsStatistics)
}
export const updateCustomEventStatus = async (id, status) => {
	return await axios.patch(`${EVENTROUTES.customEvents}/${id}/status`, {
		status,
	})
}
export const getOneEvent = async (id, params) => {
	return await axios.get(`${EVENTROUTES.name}/${id}`, {
		params: convertParams(params),
	})
}
export const deleteEvent = async (id) => {
	return await axios.delete(`${EVENTROUTES.name}/${id}`)
}

export const deleteOneEvent = async (id) => {
	return await axios.delete(`${EVENTROUTES.name}/${id}?delete_type=ONLY_THIS_EVENT`)
}

export const deleteAllEvent = async (id) => {
	return await axios.delete(`${EVENTROUTES.name}/${id}?delete_type=ALL`)
}
